import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { environment } from '../environments/environment';
import { provideAuth } from 'angular-auth-oidc-client';
import { headerInterceptor } from './header.interceptor';
import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes), 
    provideAnimationsAsync(),
    provideHttpClient(withFetch(), withInterceptors([headerInterceptor])),
    provideAuth({
      config: environment.identityConfig
    }),
    provideAnimations(),   
    provideToastr({         
      positionClass: 'toast-top-right',
      timeOut: 5000,
      preventDuplicates: true,
      newestOnTop: true,
      maxOpened: 3,
      autoDismiss: true
    }),
  ]
};
